import axios from "axios";
import { ListAction, ListIncidentAction } from "@/features/Actions/Action";
import { IncidentActionRequestModel } from "@/features/Actions/ActionRequestModel";
import User from "@/shared/models/User";
import { UserType } from "@/features/Authentication/PlatformUserInfoService";

export interface ActionResponse {
    actions: ListAction[];
    totalActions: number;
}

export class ActionService {
    private actionsURL = "/api/v1/actions";

    async getAssignableUsers(omnisearch: string, limit: number, types: UserType[]): Promise<User[]> {
        const path = `${this.actionsURL}/assignableusers`;

        const response = await axios.get(path, {
            params: {
                omnisearch: omnisearch,
                limit: limit,
                types: types,
            },
        });
        return response.data.users as User[];
    }

    async getActions(query: object | null): Promise<ActionResponse> {
        const path = `${this.actionsURL}/`;

        const response = await axios.get(path, {
            params: query,
        });
        return response.data as ActionResponse;
    }

    async createAction(action: ListAction) {
        const response = await axios.post(this.actionsURL, new IncidentActionRequestModel(action as ListIncidentAction));
        return response.data;
    }

    async getDocumentByArchiveID(id: string, docArchiveID: string, filename: string): Promise<void> {
        try {
            // Add an HTML anchor element to the page linking to the document to download
            const anchor = document.createElement("a");
            document.body.appendChild(anchor);
            const requestPath = this.actionsURL + "/" + id + "/document/" + docArchiveID;

            // Get document from server and prepare to download it to browser
            const blob = (await axios.get(requestPath, { responseType: "blob" })).data as Blob;
            const objectUrl = window.URL.createObjectURL(blob);

            anchor.href = objectUrl;
            anchor.download = filename;

            // Click the link to download the document
            anchor.click();

            // Clean up the link
            window.URL.revokeObjectURL(objectUrl);
            document.body.removeChild(anchor);
        } catch (err) {
            console.log(err);
            alert(`Error downloading ${filename}`);
        }
    }

    async acknowledgeAction(actionID: string) {
        const response = await axios.put(this.actionsURL + `/${actionID}/acknowledge`);
        return response.data;
    }

    async completeAction(actionID: string) {
        const response = await axios.put(this.actionsURL + `/${actionID}/complete`);
        return response.data;
    }

    async deleteAction(actionID: string) {
        const response = await axios.delete(this.actionsURL + "/" + actionID);
        return response.data;
    }

    async updateAction(action: ListAction) {
        const response = await axios.put(this.actionsURL + `/${action.id}`, new IncidentActionRequestModel(action as ListIncidentAction));
        return response.data;
    }
}
